/**
 * QuantityDialog - dialog potwierdzenia ilosci po zeskanowaniu kodu.
 * Wyodrebniony z KolektorPage.jsx.
 */

import React from 'react';

const QuantityDialog = ({
  pendingProduct,
  pendingQuantity,
  setPendingQuantity,
  loading,
  handleConfirmQuantity,
  handleCancelScan,
}) => {
  if (!pendingProduct) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '1rem'
    }}>
      <div style={{
        backgroundColor: 'var(--card-bg)',
        borderRadius: '12px',
        padding: '1rem',
        width: '100%',
        maxWidth: '300px',
        boxShadow: '0 10px 40px rgba(0,0,0,0.3)'
      }}>
        {/* Naglowek */}
        <div style={{
          textAlign: 'center',
          marginBottom: '0.5rem'
        }}>
          <div style={{ fontSize: '28px', marginBottom: '0.25rem' }}>&#128230;</div>

          {/* Ladowanie */}
          {pendingProduct.loading && (
            <div style={{ fontSize: '13px', color: 'var(--text-muted)' }}>
              Wyszukiwanie produktu...
            </div>
          )}

          {/* Znaleziony produkt */}
          {!pendingProduct.loading && pendingProduct.name && (
            <>
              <div style={{
                fontSize: '13px',
                fontWeight: '700',
                color: 'var(--success)',
                marginBottom: '0.25rem',
                lineHeight: '1.2'
              }}>
                &#10003; {pendingProduct.name}
              </div>
              <div style={{
                fontSize: '11px',
                color: 'var(--text-muted)',
                fontFamily: 'monospace'
              }}>
                {pendingProduct.code && <span>Kod: {pendingProduct.code} | </span>}
                EAN: {pendingProduct.ean}
                {pendingProduct.system_count !== undefined && (
                  <span style={{ color: 'var(--info)' }}> | Stan: {pendingProduct.system_count}</span>
                )}
              </div>
            </>
          )}

          {/* Nieznany produkt */}
          {!pendingProduct.loading && !pendingProduct.name && (
            <>
              <div style={{
                fontSize: '12px',
                fontWeight: '600',
                color: 'var(--danger)'
              }}>
                &#9888;&#65039; Nieznany produkt
              </div>
              <div style={{
                fontSize: '16px',
                fontWeight: '700',
                color: 'var(--purple)',
                fontFamily: 'monospace'
              }}>
                {pendingProduct.ean}
              </div>
            </>
          )}
        </div>

        {/* Pole ilosci - tylko wyswietlanie */}
        <div style={{ marginBottom: '0.5rem' }}>
          <div
            style={{
              width: '100%',
              padding: '0.4rem',
              fontSize: '28px',
              fontWeight: '700',
              textAlign: 'center',
              border: '2px solid var(--purple)',
              borderRadius: '8px',
              backgroundColor: 'var(--bg)',
              minHeight: '46px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {pendingQuantity || <span style={{ color: 'var(--text-muted)', fontSize: '16px' }}>Wpisz ilość</span>}
          </div>
        </div>

        {/* Przyciski +1 / -1 */}
        <div style={{ display: 'flex', gap: '0.4rem', marginBottom: '0.4rem' }}>
          <button
            onClick={() => {
              const current = parseFloat(pendingQuantity) || 0;
              if (current > 1) setPendingQuantity(String(current - 1));
              else if (current > 0) setPendingQuantity('0');
            }}
            style={{
              flex: 1,
              padding: '0.6rem',
              fontSize: '22px',
              fontWeight: '700',
              border: '1px solid var(--danger)',
              color: 'var(--danger)'
            }}
          >
            &#8722;1
          </button>
          <button
            onClick={() => {
              const current = parseFloat(pendingQuantity) || 0;
              setPendingQuantity(String(current + 1));
            }}
            style={{
              flex: 1,
              padding: '0.6rem',
              fontSize: '22px',
              fontWeight: '700',
              border: '1px solid var(--success)',
              color: 'var(--success)'
            }}
          >
            +1
          </button>
        </div>

        {/* Klawiatura numeryczna */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '0.3rem',
          marginBottom: '0.5rem'
        }}>
          {['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0', '⌫'].map((key) => (
            <button
              key={key}
              onClick={() => {
                if (key === '⌫') {
                  setPendingQuantity(prev => prev.slice(0, -1) || '');
                } else if (key === '.') {
                  if (!pendingQuantity.includes('.')) {
                    setPendingQuantity(prev => (prev || '0') + '.');
                  }
                } else {
                  setPendingQuantity(prev => {
                    if (prev === '0' && key !== '0') return key;
                    return (prev || '') + key;
                  });
                }
              }}
              style={{
                padding: '0.5rem',
                fontSize: '18px',
                fontWeight: '600',
                backgroundColor: key === '⌫' ? 'var(--warning)' : 'var(--border)',
                color: 'var(--text)',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              {key}
            </button>
          ))}
        </div>

        {/* Przyciski akcji */}
        <div style={{ display: 'flex', gap: '0.4rem' }}>
          <button
            onClick={() => setPendingQuantity('')}
            style={{
              padding: '0.6rem 0.8rem',
              fontSize: '12px',
              fontWeight: '600',
              backgroundColor: 'var(--danger-light)',
              color: 'var(--danger)',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            C
          </button>
          <button
            onClick={handleCancelScan}
            disabled={loading}
            style={{
              flex: 1,
              padding: '0.6rem',
              fontSize: '14px',
              fontWeight: '600',
              backgroundColor: 'var(--border)',
              color: 'var(--text-secondary)',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            Anuluj
          </button>
          <button
            onClick={handleConfirmQuantity}
            disabled={loading || !pendingQuantity || parseFloat(pendingQuantity) <= 0}
            style={{
              flex: 2,
              padding: '0.6rem',
              fontSize: '14px',
              fontWeight: '600',
              border: '1px solid var(--success)',
              color: 'var(--success)',
              opacity: (loading || !pendingQuantity || parseFloat(pendingQuantity) <= 0) ? 0.6 : 1
            }}
          >
            {loading ? '...' : 'Dodaj'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuantityDialog;
